var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top-banner",
      class: _vm.useWave === true ? "banner-with-wave" : "",
    },
    [
      _c(
        "div",
        {
          staticClass: "row mx-0 h-100 position-relative",
          attrs: { id: "TopBox" },
        },
        [
          _c("div", {
            staticClass: "img d-none d-lg-block h-100 position-absolute",
            style: { backgroundImage: "url(" + _vm.image + ")" },
          }),
          _c(
            "div",
            {
              staticClass:
                "text-box text-white w-100 d-flex justify-content-center",
            },
            [
              _c("div", { staticClass: "text-wrap d-flex flex-column" }, [
                _vm.title !== undefined
                  ? _c("h1", { domProps: { innerHTML: _vm._s(_vm.title) } })
                  : _vm._e(),
                _c("h1", { domProps: { innerHTML: _vm._s(_vm.subtitle) } }),
                _c("p", {
                  staticClass: "mt-4",
                  domProps: { innerHTML: _vm._s(_vm.description) },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "wave overflow-hidden" }, [
            _c("img", { attrs: { src: _vm.imageWave } }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }